import { withSvgIcon } from './withSvgIcon';

export const MicrosoftLogo = withSvgIcon(
  <>
    <path d="M11.5526 3.5H3.5V11.5526H11.5526V3.5Z" fill="#F25022" />
    <path d="M11.5526 12.4473H3.5V20.4999H11.5526V12.4473Z" fill="#00A4EF" />
    <path d="M20.5001 3.5H12.4474V11.5526H20.5001V3.5Z" fill="#7FBA00" />
    <path
      d="M20.5001 12.4473H12.4474V20.4999H20.5001V12.4473Z"
      fill="#FFB900"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
